import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import CookieBanner from "@/components/CookieBanner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import ChiSiamo from "@/pages/ChiSiamo";
import PercheNoi from "@/pages/PercheNoi";
import Contatti from "@/pages/Contatti";
import Privacy from "@/pages/Privacy";
import CookiePolicy from "@/pages/CookiePolicy";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <CookieBanner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/chi-siamo" element={<ChiSiamo />} />
          <Route path="/perche-noi" element={<PercheNoi />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
